import { TableCell, Tooltip } from "@mui/material";


interface TableIconCellProps {
  title?: string,
  onClick?: () => void
}

export function TableIconCell({ title, onClick, children }: React.PropsWithChildren<TableIconCellProps>) {
  return (
    <TableCell padding="checkbox" onClick={onClick} align="center">
      <Tooltip title={title ?? ""}>
        <div>
          { children }
        </div>
      </Tooltip>
    </TableCell>
  )
}
